import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { tokenState } from '../atoms/token';

const instance = axios.create({
  
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || ''; // or wherever you store your token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
